jQuery(function($) {
    $('#search-boletim').on('click', function(e) {
        e.preventDefault();
        Swal.fire({
            title: 'Pesquisar Boletim',
            html: `
                <form id="searchForm" action="` + phpVars.searchUrl + `" method="GET">
                    <label for="texto">
                        <span class="screen-reader-text">Buscar por:</span>
                        <input type="text" title="Search for:" name="texto" value="" id="texto" placeholder="Buscar por" class="search-form__field">
                        <div class="search_submit">
                            <img src="` + phpVars.iconImg + `" alt="">
                        </div>
                    </label>
                </form>
            `,
            showConfirmButton: false,
            focusConfirm: false,
            didOpen: () => {
                $('#searchForm').on('submit', function(e) {
                    e.preventDefault();
                    const query = $.trim($(this).find('[name="texto"]').val());
                    if (query !== '') {
                        const action = $(this).attr('action');
                        window.location.href = `${action}?texto=${encodeURIComponent(query)}&filter_section=boletim`;
                    }
                });
            }
        });
    });
});